import React from 'react';
import './ConfidenceScore.css';

const ConfidenceScore = ({ score, onClick }) => {
  const getColor = () => {
    if (score >= 75) return '#10b981'; // Green
    if (score >= 50) return '#f59e0b'; // Orange
    if (score >= 25) return '#ef4444'; // Red
    return '#6b7280'; // Gray
  };

  return (
    <span 
      onClick={onClick}
      style={{
        color: getColor(),
        fontWeight: '600',
        fontSize: '14px',
        cursor: onClick ? 'pointer' : 'default',
        textDecoration: onClick ? 'underline' : 'none'
      }}
      title={onClick ? 'Click to see details' : `Confidence: ${score}%`}
    >
      {score}%
    </span>
  );
};

export default ConfidenceScore;
